import {
  Component,
  effect,
  EventEmitter,
  inject,
  Input,
  input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { ShippingTemplateInterface } from '../../../../core/interfaces/shipping-templates/shipping-template-interface';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ButtonModule } from 'primeng/button';
import {
  ProductInterface,
  ProviderProductInterface,
} from '../../../../core/interfaces/product/product';
import { StoreInterface } from '../../../../core/interfaces/store/store-interface';
import {
  DynamicFormInterface,
  InputType,
  providerSettingsInterface,
} from '@component-library';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ProviderProductsService } from '../../../../core/services/provider-products/provider-products.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ProviderProductClass } from '../../../../core/classes/provider-product/provider-product';
import { InputNumberModule } from 'primeng/inputnumber';
import { GlobalMessageService } from '../../../../core/services/global-services/global-message-service/global-message.service';
import {
  concatMap,
  from,
  map,
  Observable,
  of,
  Subject,
  Subscription,
  switchMap,
  takeUntil,
  toArray,
} from 'rxjs';
import { BrandMappingsService } from '../../../../core/services/brands/brand-mappings.service';
import { BrandMappingInterface } from '../../../../core/interfaces/brands/brands-interface';
import { ProviderCategoriesGetResponseItemsInterface } from '../../../../core/interfaces/categories/provider-categories-interface';
import { ProviderCategoriesService } from '../../../../core/services/categories/provider-categories.service';
import { CategoryAttributeMappingService } from '../../../../core/services/categories/category-attribute-mapping.service';
import {
  CategoryAttributeMapping,
  DefaultValue,
} from '../../../../core/interfaces/categories/categories-interface';

import { StoreService } from '../../../../core/store/store.service';
import { datasourceInterface } from '../variants/provider-product-detail-variants.component';
import { VariantsService } from '../../../../core/services/variants/variants.service';
import { VariantsInterface } from '../../../../core/interfaces/variants/variants-interface';
import { VariantItemList } from '../../../bulk-product-addition/class/variant-item-list';
import { LocalStorageService } from '../../../../core/services/storage/local-storage.service';
import { AddVariantMatchingService } from '../../../../core/services/variants/variant-update/add-variant-matching.service';
import { DatePicker } from 'primeng/datepicker';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { Select } from 'primeng/select';
import { BroadcastChannelService } from '../../../../core/broadcast-channel/services/broadcast-channel.service';
import { RedisProviderCategoryAttributeRootInterface } from '../../../../core/interfaces/categories/provider-category-attributes-interface';
import {
  getStoreBrandMapping,
  getStoreCategoryMapping,
} from '../../functions/get-mappings-function';

@Component({
  selector: 'magenty-provider-product-detail-marketplace-special',
  imports: [
    CommonModule,
    InputTextModule,
    InputSwitchModule,
    ButtonModule,
    FormsModule,
    ReactiveFormsModule,
    InputNumberModule,
    DatePicker,
    ToggleSwitch,
    Select,
  ],
  providers: [DatePipe],
  templateUrl: './provider-product-detail-marketplace-special.component.html',
  styleUrl: './provider-product-detail-marketplace-special.component.scss',
})
export class ProviderProductDetailMarketplaceSpecialComponent
  implements OnInit, OnDestroy
{
  providerProductService = inject(ProviderProductsService);
  globalMessageService = inject(GlobalMessageService);
  brandMappingsService = inject(BrandMappingsService);
  categoryAttributeMappingService = inject(CategoryAttributeMappingService);
  providerCategoriesService = inject(ProviderCategoriesService);
  datePipe = inject(DatePipe);
  storeService = inject(StoreService);
  variantsService = inject(VariantsService);
  addVariantMatchingService = inject(AddVariantMatchingService);

  @Input() product: ProductInterface | undefined;
  @Input() providerProduct: ProviderProductInterface = new ProviderProductClass(
    this.storeService.store$()
  );
  @Input() providerSettings: providerSettingsInterface | undefined;
  store: StoreInterface;
  @Input() hbSku = '';
  @Input() isHbSku = false;
  @Input() eachVariantAProduct: boolean | undefined = false;
  @Output() tabStatus = new EventEmitter();
  @Output() hbSkuChange = new EventEmitter();
  @Output() isSave = new EventEmitter();
  @Input() variantDatasource: datasourceInterface[] = [];
  @Input() baseVariants: VariantsInterface[] = [];

  shippingTemplate: ShippingTemplateInterface[] = [];
  details: DynamicFormInterface[] = [];
  formSettings: DynamicFormInterface[] | undefined;
  detailsForm: FormGroup | undefined;
  validationSetTimeId: any;
  allErrors = {
    base: false,
    matching: false,
    variants: false,
    marketplaceSpecial: false,
  };
  subscriptionList: Subscription[] = [];
  private destroy$ = new Subject<void>();
  providerCategory: ProviderCategoriesGetResponseItemsInterface | undefined;
  subscription: Subscription | undefined;
  loading = false;
  providerCategoryAttributes = input<
    RedisProviderCategoryAttributeRootInterface[]
  >([]);
  showError = false;

  constructor(
    public ref: DynamicDialogRef,
    private localStorageService: LocalStorageService,
    private broadcastChannelService: BroadcastChannelService
  ) {
    this.store = this.storeService.store$();
    effect(() => {
      this.store = this.storeService.store$();
      this.getShippingTemplate();
    });
  }

  ngOnInit() {
    this.details = [...(this.providerSettings?.detailsFields ?? [])];
    this.formSettings = this.providerSettings?.detailsFields;
    this.detailsForm = this.formCreate();
    this.formSet();
    this.formatDate();

    this.setValue();
    this.detailsForm.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((f) => {
        this.setValue();
      });

    this.getShippingTemplate();

    this.providerCategoriesGetRequest(this.providerProduct.Category);
  }

  formatDate = () => {
    const found = this.formSettings?.find(
      (f) => f.inputType === InputType.date
    );
    if (!found || !this.detailsForm) {
      return;
    }

    const date = this.detailsForm.get(found.field);

    const formattedDate = this.datePipe.transform(date?.value, 'dd.MM.yyyy');
    date?.setValue(formattedDate);
  };

  getShippingTemplate = () => {
    this.shippingTemplate =
      this.store?.shippingTemplate.base.filter(
        (f) => f.ProviderId === this.providerProduct?.ProviderId
      ) ?? [];

    if (this.shippingTemplate.length === 1) {
      this.providerProduct.ShippingTemplateId =
        this.shippingTemplate.at(0)?.Id ?? '';
    }
  };

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.subscriptionList.map((subscription) => {
      subscription.unsubscribe();
    });
  }

  setErrors = () => {
    const {
      Name,
      Price,
      Brand,
      Category,
      CategoryAttribute,
      Variant,
      MarketPlaceSpecial,
      ProviderSku,
      ShippingTemplate,
    } = this.providerProduct.validation;

    this.allErrors = {
      base: Name.status || Price.status,
      matching: Brand.status || Category.status || CategoryAttribute.status,
      variants: Variant.status,
      marketplaceSpecial:
        ProviderSku.status ||
        ShippingTemplate.status ||
        MarketPlaceSpecial.status ||
        (this.detailsForm?.invalid ?? false),
    };
  };

  showErrorPage = () => {
    const { base, matching, variants, marketplaceSpecial } = this.allErrors;

    let message = '';

    if (base) {
      this.tabStatus.emit(0);
      message = 'Temel bölümünde boş alanlar var lütfen doldurunuz.';
    } else if (matching) {
      this.tabStatus.emit(1);
      message = 'Eşleştirme bölümünde boş alanlar var lütfen doldurunuz.';
    } else if (variants) {
      this.tabStatus.emit(2);
      message = 'Varyant bölümünde boş alanlar var lütfen doldurunuz.';
    } else if (marketplaceSpecial) {
      this.tabStatus.emit(3);
      message = 'Pazaryeri özel bölümünde boş alanlar var lütfen doldurunuz.';
    }

    const summary =
      this.providerProduct.Id.length === 0
        ? 'Pazaryerine Ürün Ekle'
        : 'Pazaryeri Ürününü Güncelle';

    this.globalMessageService.showMessage('errorMessage', summary, message);
  };

  formSet = () => {
    this.formSettings?.forEach((formSetting) => {
      const found = this.providerProduct?.Details.find(
        (f) => f.Key === formSetting.field
      );
      if (found) {
        this.detailsForm?.patchValue({ [formSetting.field]: found.Value });
      }
    });

    this.validation();
  };
  formCreate = (): FormGroup => {
    const tempForm: any = {};
    if (this.formSettings) {
      this.formSettings.forEach((formSetting) => {
        let value = formSetting.value;

        if (formSetting.inputType === InputType.modelCode) {
          value = this.providerProduct.Sku;
        }

        const control = new FormControl(
          value,
          formSetting.required ? Validators.required : null
        );

        tempForm[formSetting.field] = control;
      });
    }
    return new FormGroup<any>(tempForm);
  };

  setValue = () => {
    if (this.formSettings) {
      this.formSettings.forEach((formSetting) => {
        if (this.detailsForm && formSetting.field === 'KnowHbSku') {
          const knowHbSku = this.detailsForm.get('KnowHbSku')?.value === 'true';
          if (knowHbSku) {
            this.detailsForm.get('HbSku')?.setValidators([Validators.required]);
          } else {
            this.detailsForm.get('HbSku')?.clearValidators();
          }
        }
        const foundValue = this.detailsForm?.get(formSetting.field)?.value;
        const foundDetail = this.providerProduct?.Details?.find(
          (f) => f.Key === formSetting.field
        );
        if (foundValue !== undefined && foundDetail) {
          foundDetail.Value = foundValue;
        } else if (foundValue) {
          this.providerProduct?.Details?.push({
            Key: formSetting.field,
            Value: foundValue,
          });
        } else {
          let value = formSetting.value;

          if (formSetting.inputType === InputType.modelCode) {
            value = this.providerProduct.Sku;
          }

          this.providerProduct?.Details?.push({
            Key: formSetting.field,
            Value: value,
          });
        }
      });
      this.validation();
    }
  };

  providerCategoriesGetRequest = (categoryCode: string) => {
    if (this.providerProduct && categoryCode.length > 0) {
      this.providerCategoriesService
        .get({
          ProviderId: this.providerProduct?.ProviderId,
          CategoryId: categoryCode,
          MarketplaceIdentity: this.providerProduct.MarketplaceIdentity,
        })
        .pipe(takeUntil(this.destroy$))
        .subscribe((f) => {
          if (f && f.Items && f.Items.length > 0) {
            this.providerCategory = f.Items.at(0);
          }
        });
    }
  };

  addBrandMapping = () => {
    const storeBrandMapping = getStoreBrandMapping(
      this.store,
      this.product?.BrandId ?? '',
      this.providerProduct.MarketplaceIdentity,
      this.providerProduct.ProviderId
    );

    if (
      !storeBrandMapping &&
      this.providerSettings?.brand.supporting &&
      this.providerProduct.Category !== 'MagentyNoCheck'
    ) {
      const newBrandMatching: BrandMappingInterface = {
        Id: '',
        BrandId: this.product?.BrandId ?? '',
        ProviderId: this.providerProduct.ProviderId,
        MarketplaceIdentity: this.providerProduct.MarketplaceIdentity,
        Attribute: {
          Details: [],
          Name: this.providerProduct.getBrandId(),
          NameId: this.providerProduct.getBrandId(),
          Value: this.providerProduct.getBrandName(),
          ValueId: this.providerProduct.getBrandName(),
        },
      };

      return this.brandMappingsService.add(newBrandMatching);
    }
    return of(null);
  };
  addCategoryMapping = () => {
    const storeFoundCategoryMapping = getStoreCategoryMapping(
      this.store,
      this.product?.CategoryId ?? '',
      this.providerProduct.MarketplaceIdentity,
      this.providerProduct.ProviderId
    );

    if (
      !storeFoundCategoryMapping &&
      this.providerSettings?.category.supporting &&
      this.providerProduct.Category !== 'MagentyNoCheck'
    ) {
      const defaultValues: DefaultValue[] = [];

      if (this.providerSettings?.category.attributeSupporting) {
        this.providerProduct.Attributes.map((attribute) => {
          defaultValues.push({
            Details: [],
            Name: attribute.Name,
            NameId: attribute.Code,
            Value: attribute.Value,
            ValueId: attribute.Value,
            IsFaulty: attribute.IsFaulty,
          });
        });
      }

      const selectedCategoryMapping: CategoryAttributeMapping = {
        Id: '',
        IsAttributes: false,
        CategoryId: this.product?.CategoryId ?? '',
        ProviderId: this.providerProduct.ProviderId,
        MarketplaceIdentity: this.providerProduct.MarketplaceIdentity,
        ProviderCategory: this.providerProduct.Category,
        ProviderCategoryName: this.providerCategory?.Name ?? '',
        DefaultValues: defaultValues,
      };
      return this.categoryAttributeMappingService
        .addMatching([selectedCategoryMapping])
        .pipe(takeUntil(this.destroy$));
    }
    return of(null);
  };

  updateVariantMapping = (): Observable<any> => {
    if (!this.product || !this.product.IsVariant) return of(null);
    if (this.baseVariants.length === 0) {
      return this.variantsService.getAll(true).pipe(
        switchMap((baseVariants) => {
          this.baseVariants = baseVariants;
          return this.addVariantMapping();
        })
      );
    }

    return this.addVariantMapping().pipe(takeUntil(this.destroy$));
  };

  getVariantList = () => {
    const variantItemList: VariantItemList[] = [];

    this.variantDatasource.map((variantData) => {
      variantData.providerProductVariantList.map((providerProductVariant) => {
        const variantItem = new VariantItemList({
          Details: [],
          ProviderCategoryName: '',
          MagentyCategoryId: '',
          MagentyCategoryName: '',
          Name: providerProductVariant.Name,
          NameId: providerProductVariant.NameId,
          ProviderCategory: this.providerProduct.Category,
          Value: providerProductVariant.Value,
          ValueId: providerProductVariant.ValueId,
          VariantItemCode: variantData.productVariantItem.Code,
          VariantKey: providerProductVariant.VariantKey,
          VariantValue: providerProductVariant.VariantValue,
          DefaultValues: [],
          Values: providerProductVariant.Values.map((value) => ({
            Key: value.Key,
            Value: value.Value,
          })),
        });

        variantItemList.push(variantItem);
      });
    });

    return variantItemList;
  };

  addVariantMapping = (): Observable<any> => {
    const variantItemList: VariantItemList[] = this.getVariantList();
    const changedVariants = this.addVariantMatchingService.addVariantMapping(
      variantItemList,
      this.baseVariants,
      this.providerProduct.ProviderId,
      this.providerSettings
    );

    if (!changedVariants || changedVariants.length === 0) {
      return of(null);
    }

    return from(changedVariants).pipe(
      concatMap((variant) => this.variantsService.updateVariant(variant)),
      toArray(),
      map((results) => {
        const successCount = results.filter((result) => result).length;
        const faultyCount = results.length - successCount;

        this.globalMessageService.showStatusMessages({
          status: successCount > 0,
          summary: 'Varyant Güncelleme',
          infoDetail: `${successCount} varyant başarıyla güncellendi.`,
          errorDetail: `${faultyCount} varyant güncelleme işlemi başarısız oldu.`,
        });

        return results;
      })
    );
  };

  createProviderProductList = () => {
    const providerProductList: ProviderProductInterface[] = [];
    if (!this.product || !this.providerProduct) return;

    if (
      (this.product.IsVariant && !this.providerSettings?.Variant.supporting) ||
      this.eachVariantAProduct
    ) {
      this.product.VariantItems.forEach((variant) => {
        const foundedVariant = this.providerProduct.Variants.find(
          (f) => f.VariantItemCode === variant.Code
        );
        if (foundedVariant) {
          const tempProviderProduct: ProviderProductInterface =
            new ProviderProductClass(this.store, this.providerProduct);
          tempProviderProduct.Variants = [];
          tempProviderProduct.VariantCode = variant.Code;
          tempProviderProduct.Sku = this.product?.Sku ?? '';
          tempProviderProduct.ProviderSku = variant.Code ?? '';
          tempProviderProduct.Variants =
            this.providerProduct?.Variants.filter(
              (f) => f.VariantItemCode === variant.Code
            ) ?? [];
          providerProductList.push(tempProviderProduct);
        }
      });
    } else {
      providerProductList.push(this.providerProduct);
    }

    providerProductList.map((providerProduct) => {
      providerProduct.ListingEndDate = undefined;
      providerProduct.PassiveDate = undefined;
    });

    return providerProductList;
  };

  addProviderProduct = (
    productId: string,
    providerProductList: ProviderProductInterface[]
  ) => {
    return this.providerProductService
      .add(productId, providerProductList)
      .pipe(takeUntil(this.destroy$));
  };
  updateProviderProduct = (productId: string) => {
    return this.providerProductService
      .update(productId, this.providerProduct)
      .pipe(takeUntil(this.destroy$));
  };

  addUpdate = () => {
    /*    if (this.isHbSku) {
      this.allErrors.matching = false;
      this.allErrors.variants = false;
      this.providerProduct.Category = '';
    }*/

    this.validation();

    const { base, matching, variants, marketplaceSpecial } = this.allErrors;

    if (base || matching || variants || marketplaceSpecial) {
      this.showErrorPage();
      this.showError = true;
      return;
    }

    this.showError = false;

    const providerProductList: ProviderProductInterface[] =
      this.createProviderProductList() ?? [];

    this.loading = true;
    of(null)
      .pipe(
        concatMap(() => this.addCategoryMapping()),
        concatMap(() => this.addBrandMapping()),
        concatMap(() => this.updateVariantMapping()),

        concatMap(() => {
          if (this.providerProduct.Id.length === 0) {
            this.isSave.emit(true);
            return this.addProviderProduct(
              this.product?.Id ?? '',
              providerProductList
            );
          } else {
            return this.updateProviderProduct(this.product?.Id ?? '');
          }
        })
      )
      .subscribe({
        next: (f) => {
          if (this.providerProduct.Id.length === 0) {
            if (f) {
              const key = `${this.product?.Id}-${this.providerProduct.MarketplaceIdentity}-${this.providerProduct.ProviderId}`;
              this.localStorageService.removeItem(key);
              this.broadcastChannelService.providerProductDetailChannelSend(
                true
              );
              this.ref.close(providerProductList);
            }
          } else {
            this.broadcastChannelService.providerProductDetailChannelSend(true);
            this.ref.close([f]);
          }
        },
        error: (error) => {
          this.loading = false;
        },
      });
  };

  validation = () => {
    clearTimeout(this.validationSetTimeId);
    this.validationSetTimeId = setTimeout(() => {
      this.providerProduct?.validationFunction(
        this.providerCategoryAttributes()
      );
      this.setErrors();
    }, 100);
  };
  protected readonly InputType = InputType;
}
